import 'normalize.css';
import render from './render';
import * as app from '@/app';
const { bootstrap } = app || {};
export default typeof bootstrap === 'function' ? bootstrap(render) : render();

// generated at 2026/7/8 18:49:32 by sui v3.1.128